/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_NotesInputs */

const cs_tasks_protocol_notes = /** @type {(inputs: Tasks_Protocol_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poznámky / závady`)
};

const en_tasks_protocol_notes = /** @type {(inputs: Tasks_Protocol_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes / defects`)
};

/**
* | output |
* | --- |
* | "Notes / defects" |
*
* @param {Tasks_Protocol_NotesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_notes = /** @type {((inputs?: Tasks_Protocol_NotesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_NotesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_notes(inputs)
	return cs_tasks_protocol_notes(inputs)
});